import CustomButton from "components/button/CustomButton";
import CardLayout from "components/layout/CardLayout";
import { LOTTECARD_KTX_SERVICE_END_DATE_TEXT } from "utils/lottecardServicePolicy";
import { useNavigate } from "react-router-dom";

const LottecardServiceEnded = () => {
  const navigate = useNavigate();

  return (
    <section className="mx-auto mb-20 mt-[calc(env(safe-area-inset-top)+88px)] min-h-[65vh] max-w-md px-4">
      <CardLayout className="border-gray-300 p-6 shadow-sm">
        <div className="space-y-5">
          <div className="space-y-3 break-keep text-center">
            <h2 className="text-xl font-bold text-text-primary">
              서비스 이용이 종료되었습니다.
            </h2>
            <p className="text-sm leading-relaxed text-text-secondary">
              롯데카드 KTX 예약 서비스는 {LOTTECARD_KTX_SERVICE_END_DATE_TEXT}
              부로 종료되었습니다.
            </p>
            <p className="text-sm leading-relaxed text-text-secondary">
              신규 예약 및 결제는 이용할 수 없으며, 기존 주문내역 확인,
              승차권 확인, 예약 취소만 가능합니다.
            </p>
          </div>

          <div className="space-y-2">
            <CustomButton
              size="medium"
              onClick={() => navigate("/order-history")}
            >
              주문내역 확인하기
            </CustomButton>
            {/* <CustomButton
              size="medium"
              variant="outlined"
              className="!bg-white"
              onClick={() => navigate("/customer-center")}
            >
              고객센터
            </CustomButton> */}
          </div>
        </div>
      </CardLayout>
    </section>
  );
};

export default LottecardServiceEnded;
